import React from 'react'
import { Box, Typography } from '@mui/material'
import { AppProviderChips } from "@components"


export default function providersNotAvailabilityColumn() {

	return {
		name: 'mainProviderNames',
		label: 'Providers not available',
		options: {
			setCellProps: () => ({
				sx: { maxWidth: 100 }
			}),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "start"
				}}>
				<AppProviderChips providers={value || []} sx={{ justifyContent: 'center' }}/>
			</Box>,
		}
	}
}
